import {toast} from 'react-toastify';

const {success, error, info, warn} = toast;

export const toastService = {
    success,
    error,
    info,
    warn
}